var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 180.002,
    viewBox: "0 0 180 180.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M180.459-39.832a90,90,0,0,1-90,90,90,90,0,0,1-90-90,90,90,0,0,1,90-90,90,90,0,0,1,90,90",
    transform: "translate(-0.459 129.833)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M110.05-59.753c0,26.782-15.674,48.492-35.01,48.492S40.028-32.971,40.028-59.753,55.7-108.245,75.04-108.245s35.01,21.711,35.01,48.492",
    transform: "translate(-40.028 108.245)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M85.274-40.69c-29.306,0-55.5,7.023-72.928,18.056A89.866,89.866,0,0,0,85.827,15.431a89.863,89.863,0,0,0,73.135-37.578C141.543-33.459,115.009-40.69,85.274-40.69",
    transform: "translate(-12.346 40.69)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M75.8-7.914H65.137A13.415,13.415,0,0,1,51.761-21.29v-30.4A13.415,13.415,0,0,1,65.137-65.069H75.8A13.415,13.415,0,0,1,89.174-51.693v30.4A13.415,13.415,0,0,1,75.8-7.914",
    transform: "translate(-51.761 65.069)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M47.32-67.687c1.048,7.775-.678,14.515-3.856,15.056s-6.6-5.324-7.65-13.1.677-14.515,3.855-15.056,6.6,5.324,7.652,13.1",
    transform: "translate(-35.506 80.819)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M86.523-67.687c-1.048,7.775.678,14.515,3.855,15.056s6.6-5.324,7.652-13.1-.678-14.515-3.855-15.056-6.6,5.324-7.652,13.1",
    transform: "translate(-86.216 80.819)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M42.027-60.58q-1.766-11.644-3.533-23.288c-.427-2.818-.839-5.788.189-8.446s4.047-4.775,6.716-3.777c-1.069-5.4,4.906-9.387,10.111-11.18,8.722-3,18.076-4.532,27.225-3.349s18.083,5.229,24.25,12.089a21.564,21.564,0,0,1,4.565,7.407c1.789,5.325.65,11.138-.5,16.637q-1.374,6.554-2.75,13.107a5.854,5.854,0,0,1-1.123,2.8c-1.087,1.209-2.917,1.3-4.541,1.3l-52.081.111c-3.264.008-7.525-.8-7.956-4.033",
    transform: "translate(-38.04 111.021)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "male-180px",
    transform: "translate(-0.459 129.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0.459 -129.833)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-.541-130.833H182.238V51.948H-.541Z",
    transform: "translate(-0.849 129.443)",
    fill: "#b4bdd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(55.447 -99.833)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M39.028-109.245h72.8V-9.482h-72.8Z",
    transform: "translate(-40.418 107.855)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(16.978 -5.953)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M11.346-41.69h149.4v58.9H11.346Z",
    transform: "translate(-12.736 40.3)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(71.752 -39.832)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M50.761-66.069H90.953V-6.135H50.761Z",
    transform: "translate(-52.151 64.679)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(49.163 -61.719)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M33.972-82.183H50.355v32.014H33.972Z",
    transform: "translate(-36.104 80.287)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(119.635 -61.719)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M84.683-82.183h16.382v32.014H84.683Z",
    transform: "translate(-86.814 80.287)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(52.685 -103.691)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M36.763-112.584h78.464v57.429H36.763Z",
    transform: "translate(-38.538 110.412)",
    fill: "#fffefe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMale);
export default __webpack_public_path__ + "static/media/profile-male.2577e3db291202759a590c2862202ce4.svg";
export { ForwardRef as ReactComponent };